import { put, call, takeLatest } from 'redux-saga/effects'
import {  dashboardLoaderAC } from '../system/systemActionCreators'

import {
    IdTransferCashDesksStateDataItem,

    typeTransferCashDesksFilters
} from "model/dashboardTransferCashDesks/dTransferCashDesksReducer";


import {
    getTransferCashDesksList
} from 'model/dashboardTransferCashDesks/dTransferCashDesksAPI';
import { typeRequestPagination } from 'model/system/constants';

import {

    dTransferCashDesksSetDataAC,
    dTransferCashDesksSetDataSagaAC
} from 'model/dashboardTransferCashDesks/dTransferCashDesksActionCreators';
import { errorGenerator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = ( tempResponseData: any ): IdTransferCashDesksStateDataItem[] => {
    return tempResponseData.map(( item: IdTransferCashDesksStateDataItem ) => {
        return (
            {
                id: item.id,
                posSnNumber: item.posSnNumber,
                status: item.status,
                to: item.to,
                date:item.date,
                whoDidIt: item.whoDidIt
            }
        )
    })
}

// Get data function-generator
function* getData( payload: {  filters: typeTransferCashDesksFilters,paginationRequest: typeRequestPagination } ) {

    let response = yield call(getTransferCashDesksList, payload)

    if (response.status === 200) {

        const tempData: IdTransferCashDesksStateDataItem[] = tempDataMapper(response.data)

        yield put(dTransferCashDesksSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}

// ---------------------------------------------------------------------------------------------------------------------
// Saga set data
export function* dTransferCashDesksSetDataWorker(
    actionObject: {
        type: string,
        payload: {
            token: string,
            refreshToken: string,
            filters: typeTransferCashDesksFilters, paginationRequest: typeRequestPagination
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dTransferCashDesksSetDataWatcher() {
    yield takeLatest(dTransferCashDesksSetDataSagaAC.type, dTransferCashDesksSetDataWorker)
}

// // ---------------------------------------------------------------------------------------------------------------------
// // Saga add data item
// export function* dTransferCashDesksAddItemWorker( actionObject: {
//     type: string,
//     payload: {
//         itemObject: IdTransferCashDesksStateDataItem,
//         token: string,
//         refreshToken: string,
//         filters: typeTransferCashDesksFilters
//     }
// } ) {
//
//     yield put(dashboardLoaderAC(true))
//
//     let response = yield call(addTransferCashDesksItem, {
//         token: actionObject.payload.token,
//         dataObject: actionObject.payload.itemObject
//     })
//
//     if (response.status === 401) {
//         const refreshTokenResponse = yield call(setRefreshToken, { refreshToken: actionObject.payload.refreshToken })
//         if (refreshTokenResponse.status === 200) {
//             const newPayload = {
//                 ...actionObject.payload, ...{
//                     token: `Bearer ${refreshTokenResponse.data.access_token}`,
//                     refreshToken: refreshTokenResponse.data.refresh_token
//                 }
//             }
//             yield put(refreshTokensAC(newPayload.token, newPayload.refreshToken))
//             // @ts-ignore
//             response = yield call(addTransferCashDesksItem, newPayload)
//         }
//     }
//
//     if (response.status === 200) {
//
//         yield notificationCreator('SUCCESS_ADD_ITEM')
//         yield getData({
//             token: actionObject.payload.token,
//             refreshToken: actionObject.payload.refreshToken,
//             filters: actionObject.payload.filters,
//             paginationRequest: actionObject.payload.pagination
//         })
//
//     } else {
//         yield errorGenerator(response)
//     }
//     yield put(dashboardLoaderAC(false))
// }
//
// export function* dTransferCashDesksAddDataWatcher() {
//     yield takeLatest(dTransferCashDesksAddItemSagaAC.type, dTransferCashDesksAddItemWorker)
// }

// // ---------------------------------------------------------------------------------------------------------------------
// // // Saga edit data item
// export function* dTransferCashDesksEditDataItemWorker(
//     actionObject: {
//         type: string,
//         payload: {
//             detailItemObject: IdTransferCashDesksStateDataItem,
//             token: string,
//             refreshToken: string,
//             filters: typeTransferCashDesksFilters
//         }
//     }
// ) {
//
//     yield put(dashboardLoaderAC(true))
//
//     let response = yield call(changeTransferCashDesksItem, {
//         token: actionObject.payload.token,
//         dataObject: actionObject.payload.detailItemObject
//     })
//     if (response.status === 401) {
//         const refreshTokenResponse = yield call(setRefreshToken, { refreshToken: actionObject.payload.refreshToken })
//         if (refreshTokenResponse.status === 200) {
//             const newPayload = {
//                 ...actionObject.payload, ...{
//                     token: `Bearer ${refreshTokenResponse.data.access_token}`,
//                     refreshToken: refreshTokenResponse.data.refresh_token
//                 }
//             }
//             yield put(refreshTokensAC(newPayload.token, newPayload.refreshToken))
//             // @ts-ignore
//             response = yield call(changeTransferCashDesksItem, newPayload)
//         }
//     }
//     if (response.status === 200) {
//        yield notificationCreator('SUCCESS_CHANGE_ITEM')
//
//         yield getData({
//             token: actionObject.payload.token,
//             refreshToken: actionObject.payload.refreshToken,
//             filters: actionObject.payload.filters
//         })
//
//         if (actionObject.payload.detailItemObject.responses) {
//           yield put(dTransferCashDesksSetDetailItemAC(actionObject.payload.detailItemObject.id))
//         }
//     } else {
//         yield errorGenerator(response)
//     }
//
//     yield put(dashboardLoaderAC(false))
//
// }
//
// export function* dTransferCashDesksEditDataWatcher() {
//     yield takeLatest(dTransferCashDesksEditItemSagaAC.type, dTransferCashDesksEditDataItemWorker)
// }
//


// // ---------------------------------------------------------------------------------------------------------------------
